module.exports = __webpack_public_path__ + "img/Day1_final.8492b91c.jpg";